// plugins/vuetify.ts

// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

// Composables
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

// Načti uloženou preferenci tématu z localStorage (default: dark)
const savedTheme = typeof localStorage !== 'undefined' ? localStorage.getItem('theme') : null
const defaultTheme = (savedTheme === 'light' || savedTheme === 'customDarkTheme')
  ? savedTheme
  : 'customDarkTheme'

// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
export default createVuetify({
  components, // Zaregistruje všechny komponenty Vuetify
  directives, // Zaregistruje všechny direktivy Vuetify
  theme: {
    defaultTheme, // Z localStorage nebo dark jako výchozí
    themes: {
      light: {
        dark: false,
        colors: {
          background: '#FFFFFF', // Výchozí pozadí nastaveno na šedou
          //primary: '#1976D2',
          primary: '#00D4FF', // Definice primární barvy
          secondary: '#424242',
          accent: '#82B1FF',
          error: '#E53935',
          info: '#2196F3',
          success: '#4CAF50',
          warning: '#FFC107',
          brand: '#0966ff', // Definice barvy pro 0D47A1
          brandLight: '#b9d4ff', // Definice barvy pro 0D47A1
          accentcolor: '#f5c83f', // Definice barvy pro D32F2F
          iconcolor: "#999999",
          energycolor: "#1976D2",
          alertcolor: "#c8102e",
          firstLineColor: 'rgba(163,10,54,255)',
          secondLineColor: '#fb9124',
          thirdLineColor: '#74c476',
          fourthLineColor: '#9e9e9e',
          description: '#666',
          modalBackground: 'rgb(37, 37, 37)',
          sheetBackground: '#f2f2f7',
          sheetSection: '#ffffff',
          sheetText: '#000000',
          sheetTextSecondary: 'rgba(60, 60, 67, 0.6)',
          sheetCloseBtn: '#ffffff',
          ice: '#00D4FF',
          eventFree: '#005a32',
          eventFull: 'rgba(163,10,54,255)'
        },
      },
      customDarkTheme: {
        dark: true, // Definujeme, že se jedná o tmavé téma
        colors: {
          primary: '#00D4FF', // Definice primární barvy
          secondary: '#42A5F5', // Definice sekundární barvy
          accent: '#9C27B0', // Akcentní barva
          error: '#FF5252', // Barva pro chyby
          info: '#2196F3', // Barva pro informaci
          success: '#4CAF50', // Barva pro úspěch
          warning: '#FB8C00', // Barva pro varování
          background: '#060810', // Vlastní barva pozadí pro tmavé téma
          mhblue: 'rgba(35,45,70,255)', // Vlastní barva
          white: 'rgba(240,240,240,255)', // Vlastní barva
          mhred: 'rgba(163,10,54,255)', // Vlastní barva
          mhgold: '#BBA53D', // Vlastní barva
          listBackground: 'rgba(35,45,70,0.8)',
          firstLineColor: 'rgba(163,10,54,255)',
          secondLineColor: '#fb9124',
          thirdLineColor: '#74c476',
          fourthLineColor: '#9e9e9e',
          gold: '#BBA53D',
          brand: '#0966ff',
          sheetBackground: '#0C1020',
          sheetSection: '#1C2640',
          sheetText: '#ffffff',
          sheetTextSecondary: 'rgba(255, 255, 255, 0.5)',
          sheetCloseBtn: '#2c2c2e',
          ice: '#00D4FF',
        },
      },
    },
  },
})
